<template>
	<div class="">
		<el-breadcrumb separator-class="el-icon-arrow-right" class="m-b-20 breadcrumb-pc">
			<el-breadcrumb-item class="color_A6A6A6"><span class="com_pointer" @click="$router.push('/pass')">知识宝典</span></el-breadcrumb-item>
			<el-breadcrumb-item>我的订单</el-breadcrumb-item>
		</el-breadcrumb>

		<!-- PC端表格 -->
		<div class="table-pc">
			<el-table :data="orders" v-loading="loading" style="width: 100%;" stripe>
				<el-table-column prop="order_no" label="订单号" min-width="180"></el-table-column>
				<el-table-column prop="package_name" label="套餐名称" min-width="150"></el-table-column>
				<el-table-column prop="amount" label="金额" width="100" align="center">
					<template slot-scope="scope">
						<span class="font_weight" style="color: #E6A23C;">¥{{ scope.row.amount }}</span>
					</template>
				</el-table-column>
				<el-table-column label="状态" width="100" align="center">
					<template slot-scope="scope">
						<el-tag :type="getStatusType(scope.row.payment_status)" size="small">
							{{ getStatusText(scope.row.payment_status) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="create_at" label="下单时间" width="180" align="center"></el-table-column>
			</el-table>
		</div>

		<!-- 移动端卡片列表 -->
		<div class="cards-mobile" v-loading="loading">
			<div class="order-card" v-for="(item, index) in orders" :key="index">
				<div class="order-card-header">
					<span class="order-card-name">{{ item.package_name }}</span>
					<el-tag :type="getStatusType(item.payment_status)" size="mini">
						{{ getStatusText(item.payment_status) }}
					</el-tag>
				</div>
				<div class="order-card-body">
					<div class="order-card-amount">¥{{ item.amount }}</div>
					<div class="order-card-no">订单号：{{ item.order_no }}</div>
					<div class="order-card-time">{{ item.create_at }}</div>
				</div>
			</div>
		</div>

		<div v-if="!loading && orders.length === 0" class="text_c p-30">
			<i class="el-icon-tickets" style="font-size: 60px; color: #ccc;"></i>
			<p class="color_999 m-t-10">暂无订单记录</p>
<el-button type="primary" size="small" class="m-t-10" @click="$router.push({path:'/center',query:{tab:'passPackages'}})"
					style="background-color: #163F88; border-color: #163F88;">去购买套餐</el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: "PassOrders",
	data() {
		return {
			loading: false,
			orders: [],
		};
	},
	activated() {
		this.initPage();
	},
	mounted() {
		this.initPage();
	},
	methods: {
		initPage() {
			if (!localStorage.getItem('u_token')) {
				this.$message.info('请先登录！');
				this.$router.push('/login');
				return;
			}
			this.getOrders();
		},
		getOrders() {
			if (this.loading) return;
			this.loading = true;
			this.$api.authPass.getOrderList({}).then((res) => {
				if (res.code == 1) {
					this.orders = (res.data && res.data.data) || [];
				} else {
					this.orders = [];
				}
			}).catch(() => {}).finally(() => {
				this.loading = false;
			});
		},
		getStatusType(status) {
			const map = { 0: 'warning', 1: 'success', 2: 'danger', 3: 'info' };
			return map[status] || 'info';
		},
		getStatusText(status) {
			const map = { 0: '待支付', 1: '已支付', 2: '已取消', 3: '已退款' };
			return map[status] || '未知';
		}
	}
};
</script>
<style scoped>
.cards-mobile {
	display: none;
}

@media screen and (max-width: 768px) {
	.table-pc {
		display: none;
	}
	.breadcrumb-pc {
		display: none;
	}
	.cards-mobile {
		display: block;
	}
	.order-card {
		background: #fff;
		border-radius: 8px;
		padding: 15px;
		margin-bottom: 12px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	}
	.order-card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}
	.order-card-name {
		font-weight: bold;
		font-size: 14px;
		flex: 1;
		margin-right: 10px;
	}
	.order-card-body {
		font-size: 13px;
		color: #666;
	}
	.order-card-amount {
		font-size: 18px;
		font-weight: bold;
		color: #E6A23C;
		margin-bottom: 6px;
	}
	.order-card-no {
		font-size: 12px;
		color: #999;
		margin-bottom: 4px;
	}
	.order-card-time {
		font-size: 12px;
		color: #999;
	}
}
</style>
